import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumbers, caid } = CommonParameters;

export const directDebitCancel: IMcAppType = {
  name: "directDebitCancel_SAP",
  path: "/my-account/direct-debit/cancel",
  parameters: {
    required: ["caid"],
    properties: { caid },
  },
  description: "Cancel Direct Debit for given account",
  navFlow: NavFlow.FOCUS,
  title: "Cancel direct debit",
  parent: Tab.MORE,
  conditions: {
    intent: "directDebitCancel",
    customerType: CustomerType.sap,
  },
};

export const directDebitCancel_KRAKEN: IMcAppType = {
  name: "directDebitCancel_KRAKEN",
  path: "/my/direct-debit/cancel",
  parameters: {
    properties: { accountNumbers },
  },
  description: "Cancel Direct Debit for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Cancel direct debit",
  parent: Tab.MORE,
  conditions: {
    intent: "directDebitCancel",
    customerType: CustomerType.kraken,
  },
};
